import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { CoreUiAlertComponent } from "./molecules/alert/alert.component";
@NgModule({
    declarations: [
        CoreUiAlertComponent
    ],
    imports: [
        CommonModule,
    ],
    exports: [
        CoreUiAlertComponent
    ]
})
export class CoreUiAlertsModule { }